import React, { useState, useEffect } from "react";
import StyledHeader from "./styles";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
export default function Header() {
  const [navbarVisible, setNavbarVisible] = useState(true);
  let prevScrollY = 0; // Initialize prevScrollY

  const handleScroll = () => {
    const scrollY = window.scrollY;

    // Show navbar when scrolling up or when at the top of the page
    if (window.innerWidth <= 991) {
      if (scrollY < prevScrollY || scrollY === 0) {
        setNavbarVisible(true);
      } else {
        setNavbarVisible(false);
      }
      prevScrollY = scrollY;
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <StyledHeader
      style={{ display: navbarVisible ? "block" : "none" }}
      className="mainnavbar"
    >
      <Container className="nav-box">
        <div className="d-flex justify-content-end align-items-center position-relative">
          <a href="https://www.swmc.com" target="_blank" rel="noreferrer">
            <Image
              className="logoImage"
              src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
            />
          </a>
          
          </div><div className="desktop-AccessibilityMenu-show">
            <UserWayAccessibilityMenu color="black" width={40} height={40}/>
          </div>
         
          
               <div></div>
        <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="black" width={40} height={40}/>
      </div>
      </Container>
    </StyledHeader>
  );
}
